import { defineMessages } from 'react-intl';

export default defineMessages({
  tryPeriodFinishTittle: {
    id: 'cboard.components.PremiumFeature.tryPeriodFinishTittle',
    defaultMessage: 'Your free trial has ended'
  },
  featureBlockedTittle: {
    id: 'cboard.components.PremiumFeature.featureBlockedTittle',
    defaultMessage: 'This feature is blocked'
  },
  featureBlockedText: {
    id: 'cboard.components.PremiumFeature.featureBlockedText',
    defaultMessage:
      'Cboard disabled this feature. To continue using it and all the features like public boards, online voices, advanced edit functions and many more, please upgrade'
  },
  upgradeNow: {
    id: 'cboard.components.PremiumFeature.upgradeNow',
    defaultMessage: 'Upgrade now'
  }
});
